import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';


// Les intercepteurs HTTP ne peuvent pas être injectés avec le raccourci "providedIn" que l'on
// utilise pour tous les autres services. Ils doivent en effet être rattachés à un composant
// spécifique d'Angular (HTTP_PROVIDERS), ce qui nécessite une déclaration explicite dans un module.
// @Injectable({providedIn:'root'})
@Injectable()
export class HttpErrorHandlerInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // On se sert d'un en-tête HTTP uniquement comme moyen de court-circuiter cet intercepteur
        // pour certains services. Mais il faut supprimer cet en-tête avant d'envoyer effectivement
        // la requête, sans quoi les web services refuseront la requête à cause de cet en-tête inconnu.
        // REF
        // https://stackoverflow.com/q/49047652
        // https://stackoverflow.com/a/49047764
        const headerBypassErrorInterceptor: boolean = req.headers.has('X-BYPASS-ERROR-INTERCEPTOR');
        if (headerBypassErrorInterceptor) {
            const headers = req.headers.delete('X-BYPASS-ERROR-INTERCEPTOR');
            return next.handle(req.clone({ headers }));
        } else {
            return next.handle(req).pipe(
                tap(
                    // En cas de réussite (premier paramètre de tap()), on ne fait rien :
                    () => { },
                    // En cas d'erreur, on exploite les métadonnées de la réponse pour gérer l'erreur
                    error => {
                        if (error instanceof HttpErrorResponse) {
                            const errorResponse: HttpErrorResponse = <HttpErrorResponse>error;

                            // Un status à 0 correspond a priori à un problème réseau - la requête n'a pas
                            // pu être traitée par le serveur, car celui-ci est injoignable ou coupé.
                            if (errorResponse.status === 0) {
                                alert('Une erreur réseau est survenue. Merci de prendre contact pour signaler ce problème.');
                            }

                            // S'il y a un code réponse, le serveur a probablement renvoyé un message d'erreur, dans le body
                            // TODO Récupérer le code/message dans le body
                            // TODO plus généralement: mieux gérer les différentes erreurs possibles

                            if (errorResponse.status === 400) {
                                this.router.navigate(['/authentification']);
                            }
                            // Cas des erreurs d'authentification (401)
                            else if (errorResponse.status === 401 || errorResponse.status === 403) {
                                this.router.navigate(['/acces-interdit']);
                            }
                            if (errorResponse.status !== 404) {
                                alert('Une erreur est survenue dans l\'application. Merci de prendre contact pour signaler ce problème.');
                            }
                        }
                    }
                )
            );
        }
    }
}
